<template>
  <div id="app">
    <Top></Top>
    <Menu></Menu>
    <img style="width: 1200px; height: 210px;margin-bottom: 15px;" :src="this.$store.state.info.factoryUrl" fit="fill"></img>
    <router-view />
    <Bottom></Bottom>
  </div>
</template>

<script>
  import Vuex from 'vuex'
  import Bottom from '@/components/common/Bottom'
  import Top from '@/components/common/Top'
  import Menu from '@/components/common/Menu'

  import {
    getInfo
  } from '@/api/top.js'

  import {
    getAllCarousel
  } from '@/api/carousel.js'

  export default {
    name: 'App',
    components: {
      Top,
      Menu,
      Bottom,
    },
    created() {
      getInfo("info/get", this.$store.state.info);
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin: 0px auto;
    width: 100%;
    height: 100%;
    background-color: #F2F2F2;
/*    -webkit-user-select: none;
    -moz-user-select: none; */
  }

  span {
    font-family: "Microsoft YaHei"
  }

  .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    background-color: royalblue;
    color: white;
  }

  .el-tabs--border-card>.el-tabs__header .el-tabs__item+.el-tabs__item, .el-tabs--border-card>.el-tabs__header .el-tabs__item:first-child{
    font-size: 15px;
    font-weight: 600;
  }

  .el-tabs__item {
    font-family: "Microsoft YaHei";
    color: grey;
  }

  ::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue